import React from 'react';
import { BookOpen, CheckCircle, Clock, Users } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { CoursePrice } from '../data/packagesData';

type PackageCardProps = {
  course: CoursePrice;
};

const PackageCard: React.FC<PackageCardProps> = ({ course }) => {
  const navigate = useNavigate();

  return (
    <article className="flex h-full flex-col overflow-hidden rounded-[2rem] border border-blue-100 bg-white shadow-float transition-transform duration-300 hover:-translate-y-1 hover:shadow-lift">
      <div className="bg-ink px-7 py-6 text-white">
        <p className="mb-2 text-sm font-bold text-sun">
          {course.sessionType}
        </p>
        <h3 className="text-2xl font-bold">{course.title}</h3>
      </div>

      <div className="flex flex-1 flex-col p-7">
        <div className="mb-5 flex flex-wrap gap-4 text-gray-600">
          <span className="flex items-center">
            <Clock className="mr-2 h-5 w-5 text-blue-600" />
            {course.duration}
          </span>
          <span className="flex items-center">
            <Users className="mr-2 h-5 w-5 text-blue-600" />
            {course.sessionType}
          </span>
        </div>

        <p className="mb-5 text-gray-600">{course.description}</p>

        {course.pricePerSession && (
          <p className="mb-6 font-display text-4xl font-bold text-blue-700">
            {course.pricePerSession} lei
            <span className="ml-1 text-base font-medium text-gray-500">/ ședință</span>
          </p>
        )}

        {course.packages && (
          <div className="mb-7 divide-y divide-blue-100 border-y border-blue-100">
            {course.packages.map((pkg) => (
              <div key={pkg.name} className="flex items-center justify-between gap-4 py-4">
                <div>
                  <p className="font-display text-lg font-bold text-ink">{pkg.name}</p>
                  <p className="text-sm text-gray-500">{pkg.sessionsPerMonth} ședințe / lună</p>
                </div>
                <div className="text-right">
                  {pkg.totalPrice && (
                    <p className="font-display text-xl font-bold text-blue-700">
                      {pkg.totalPrice} lei <span className="block text-xs font-semibold text-gray-500">/ lună</span>
                    </p>
                  )}
                  {pkg.discount && <p className="rounded-full bg-mint px-3 py-1 text-sm font-bold text-ink">{pkg.discount}% discount</p>}
                </div>
              </div>
            ))}
          </div>
        )}

        <ul className="mb-7 space-y-3">
          {course.features.map((feature) => (
            <li key={feature} className="flex items-start text-gray-700">
              <CheckCircle className="mr-3 mt-0.5 h-5 w-5 flex-shrink-0 text-green-500" />
              <span>{feature}</span>
            </li>
          ))}
        </ul>

        <button
          type="button"
          onClick={() => navigate('/contact')}
          className="mt-auto flex w-full items-center justify-center rounded-full bg-blue-600 py-3 font-bold text-white transition-all duration-200 hover:-translate-y-0.5 hover:bg-blue-700"
        >
          <BookOpen className="mr-2 h-5 w-5" />
          Înscrie-te acum
        </button>
      </div>
    </article>
  );
};

export default PackageCard;
